// extracted by mini-css-extract-plugin
export default {"mainLink":"MainLink_mainLink__Yn5yr","Shimiring":"MainLink_Shimiring__o8Yrv"};